export default {
  default: {
    imageDeleted: 'Image Deleted ',
    imageUpdated: 'Image Updated',
    imagesDeleted: 'Images Deleted ',
  },
}
